import { AdminClientReport } from './AdminClientReport';

export default AdminClientReport;